
      <p-fileUpload id="qr" accept="image/*" maxFileSize="5000000" fileLimit="1" (onSelect)="onFileChanged($event)"
      (onBeforeUpload)="onUpload()"></p-fileUpload>
      <img id="outputTemp" class="hidden">
